import React from 'react';
import { connect } from "react-redux";
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import updateArticle from './../../../API/Admin/PutArticle'
import Loader from './../../../Global/loader'

class UpdateArticle extends React.Component {
    constructor(props) {
        super(props); 
        this.submitUpdate = this.submitUpdate.bind(this);
    }

    state={
        loading: true
    }

    componentDidMount = async () => {
        this.setState({
            loading: true
        })

        await this.setState({
            loading: false
        }) 
    }

    
    handleUpdateChange = async (e) => {
        await this.props.mapState("ADMIN_CHANGE_ONE_ARTICLE_DETAILS", e.target) 
    }

    submitUpdate = async (e) =>{
        this.setState({ loading: true })
        e.preventDefault()
        let updatePP = await updateArticle(this.props.oneClientInfo.uuid, this.props.oneArticle)
        if(updatePP.data.data.operationResult === "SUCCESS"){
            store.addNotification({
                title: "Uspješno!",
                message: "Promjena Artikla je izvršena",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.setState({ loading: false })
        }
        else(
            store.addNotification({
                title: "Greška!",
                message: "Došlo je do pogreške prilikom promjene artikla, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })
        )
        this.setState({ loading: false })
        this.props.goBack()
    }

    render(){  
        return (
            <>
                {this.state.loading ?
                    <div style={{position: "sticky", marginTop: "50px", left: "50%"}}>
                        <Loader />
                    </div>
                :
                <form style={{padding: "40px"}}>
                    <div className="row">          
                        <div className="col col-sm-12 col-lg-6 col-md-12">
                            <div className="form-group row">
                                <label htmlFor="naziv" className="col-sm-4 col-form-label">Naziv</label>
                                <div className="col-sm-8">
                                    <input      
                                            id="naziv"                          
                                            type="text"
                                            value={this.props.oneArticle.naziv}
                                            onChange={e => this.handleUpdateChange(e)}
                                        />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="jed_mjera" className="col-sm-4 col-form-label">Mjerna jedinica</label>
                                <div className="col-sm-8">
                                    <input
                                        id="jed_mjera"  
                                        type="text"
                                        value={this.props.oneArticle.jed_mjera}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="kataloski_broj" className="col-sm-4 col-form-label">Kataloški broj</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="kataloski_broj"                         
                                        type="text"
                                        value={this.props.oneArticle.kataloski_broj}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div>  

                            <div className="form-group row">
                                <label htmlFor="sifra" className="col-sm-4 col-form-label">Šifra</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="sifra"                         
                                        type="text"
                                        value={this.props.oneArticle.sifra}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div> 

                            <div className="form-group row">
                                <label htmlFor="dodatni_naziv" className="col-sm-4 col-form-label">Dodatan naziv</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="dodatni_naziv"                         
                                        type="text"
                                        value={this.props.oneArticle.dodatni_naziv}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div> 

                            <div className="form-group row">
                                <label htmlFor="jed_kolicina" className="col-sm-4 col-form-label">Količina</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="jed_kolicina"                         
                                        type="number"
                                        value={this.props.oneArticle.jed_kolicina}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div> 

                            <div className="col-sm-4" style={{float:"right",padding: "0px"}}>
                                <button                                     
                                    className="btn btn-info" 
                                    style={{padding:"10px"}} 
                                    onClick={(e) => this.submitUpdate(e)}
                                >
                                    Spremi
                                </button>
                            </div>                                  
                        </div>                        
        
                        
                    </div>           
                    
                    <div 
                        className="btn btn-default" 
                        style={{/*width: "100%",*/ marginBottom: "10px", marginTop: "10px"}}
                        onClick={(e) => this.props.goBack(e)}
                    >
                        <BsBackspaceFill size={30} />  <strong>Nazad</strong>
                    
                    </div>    
                
                </form>
                }        
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        oneClientInfo: state.adminClient.oneClient,
        oneArticle: state.adminClient.oneArticle
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(UpdateArticle);


